import React, { ReactNode } from "react";
import styles from "./pageHero.module.css";

export type PageHeroTone =
    | "blue"
    | "green"
    | "violet"
    | "amber"
    | "pink"
    | "teal"
    | "slate";

export interface PageHeroStat {
    label: string;
    value: ReactNode;
}

interface PageHeroProps {
    eyebrow?: string;
    title: ReactNode;
    subtitle?: ReactNode;
    icon?: ReactNode;
    tone?: PageHeroTone;
    actions?: ReactNode;
    stats?: PageHeroStat[];
}

export const PageHero: React.FC<PageHeroProps> = ({
    eyebrow,
    title,
    subtitle,
    icon,
    tone = "blue",
    actions,
    stats,
}) => {
    return (
        <div className={styles.hero} data-tone={tone} data-tour="page-hero">
            <div className={styles.glow} />
            <div className={styles.row}>
                <div className={styles.left}>
                    {icon && <div className={styles.iconBox}>{icon}</div>}
                    <div className={styles.titleWrap}>
                        {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
                        <h1 className={styles.title}>{title}</h1>
                        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    </div>
                </div>
                {actions && <div className={`${styles.actions} pagehero-actions`}>{actions}</div>}
            </div>
            {stats && stats.length > 0 && (
                <div className={styles.stats}>
                    {stats.map((s, i) => (
                        <div className={styles.stat} key={`${s.label}-${i}`}>
                            <span className={styles.statLabel}>{s.label}</span>
                            <span className={styles.statValue}>{s.value}</span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
